import { TestConnection } from "../api/ftpTestAPI"

interface FTPCreds {
    host: string,
    port: number,
    user: string,
    password: string,
    path: string,
    caller: String
}

export const FTPValidation = async (
    { host, port, user, password, path, caller }: FTPCreds,
    onError?: (message: string, host?: string, port?: number, path?: string) => void
): Promise<boolean> => {
    const logError = (message: string) => {
        if (onError) {
            onError(message, host, port, path);
        }
    };

    const errors: string[] = [];

    // Input validation - collect errors instead of throwing immediately
    if (!host || !host.trim()) {
        errors.push('Host is required');
    }

    if (!port || port <= 0 || port > 65535) {
        errors.push('Valid port number is required (1-65535)');
    }

    if (!user || !user.trim()) {
        errors.push('Username is required');
    }

    if (!password) {
        errors.push('Password is required');
    }

    if (caller === "Save" && (!path || !path.trim())) {
        errors.push('Path is required');
    }

    // If there are validation errors, log and throw them all together
    if (errors.length > 0) {
        const combinedErrorMsg = errors.join(', ');
        logError(combinedErrorMsg);
        throw new Error(combinedErrorMsg);
    }

    let data = {
        host, 
        port, 
        username: user, 
        password
    }

    try {
        let res = await TestConnection(data);
        if (res !== "Success") {
            const errorMsg = `Failed to connect to the host ${res}`;
            logError(errorMsg);
            throw new Error(errorMsg);
        }
        
        // Return true if validation and connection are successful
        return true;
        
    } catch (error: any) {
        const errorMsg = error?.message || 'Failed to connect to the host please check the data if its proper or not';
        logError(errorMsg);
        throw new Error(errorMsg);
    }
}